module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-select', _vm._b({
    staticClass: "filter-select filter-select-indicator",
    attrs: {
      "bottom": "",
      "single-line": "",
      "hide-details": "",
      "items": _vm.typeDocuments,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.documentType),
      callback: function($$v) {
        _vm.documentType = $$v
      },
      expression: "documentType"
    }
  }, 'v-select', _vm.$attrs, false)), _vm._v(" "), _c('v-text-field', _vm._b({
    staticClass: "input-border-inset input-form-select",
    on: {
      "blur": _vm.searchCustomer,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchCustomer($event)
      },
      "input": _vm.typeDocumentType
    },
    model: {
      value: (_vm.numDocument),
      callback: function($$v) {
        _vm.numDocument = $$v
      },
      expression: "numDocument"
    }
  }, 'v-text-field', _vm.$attrs, false)), _vm._v(" "), (_vm.$v.documentType.$invalid) ? _c('p', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\tEl tipo de Identificación es requerido\n\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.numDocument.$invalid) ? _c('p', {
    staticClass: "caption red--text text-caption"
  }, [_vm._v("\n\t\t\tNumero de Documento es requerido\n\t")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3862abc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/type-document-input.vue
// module id = 970
// module chunks = 2 4 5 20 22